import React, { useState, useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';
import MarkdownIt from 'markdown-it';
import 'github-markdown-css/github-markdown.css';
import '../markdown-styles.css';
import hljs from 'highlight.js';

import termsOfUseText from '../assets/termsOfUseText.js';

const TypingMarkdown = ({ content = '', speed = 0, className }) => {
    const [displayText, setDisplayText] = useState('');
    const theme = useTheme();

    const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: false,
        highlight: function (str, lang) {
            if (lang && hljs.getLanguage(lang)) {
                try {
                    return hljs.highlight(str, { language: lang }).value;
                } catch (__) { }
            }
            return hljs.highlightAuto(str).value;
        },
    });

    const indexRef = useRef(0);

    useEffect(() => {
        setDisplayText(content);
    }, [content]);

    return (
        <Box
            sx={{
                padding: 2,
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.default,
                borderRadius: 1,
                '& pre': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#f6f8fa',
                    padding: 1,
                    borderRadius: 1,
                    overflowX: 'auto',
                },
                '& code': {
                    fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
                },
            }}
            className={`markdown-body ${className}`}
            dangerouslySetInnerHTML={{ __html: md.render(displayText) }}
        />
    );
};

const TermsOfUse = () => {
    return (
        <Box>
            <TypingMarkdown content={termsOfUseText} speed={0} />
        </Box>
    );
};

export default TermsOfUse;
